import React from "react";
import "./CommunityLiveCommentSection.css";

const CommunityLiveCommentSection = ({ liveComments, setLiveSectionVisible }) => {
  return (
    <section className="communityLiveCommentSection">
      <div className="communityLiveHeader">
        <p className="communityLiveTitle">Live comment section</p>
        <button
          className="communityCloseLive"
          onClick={() => setLiveSectionVisible(false)}
        >
          Close live section
        </button>
      </div>
      <div className="communityLiveMessages">
        {liveComments.map((comment, index) => (
          <div key={index} className="communityLiveMessage">
            <div className={`communityLiveDot ${comment.dotColor}`}></div>
            <p className="communityLiveText">{comment.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CommunityLiveCommentSection;
